const Loader: React.FC = () => {
  return (
    <div className='flex justify-center items-center p-4'>
      <div className='w-20 h-20 border-4 border-t-black border-gray-300 rounded-full animate-spin' />
    </div>
  );
};

export default Loader;
